import { CATEGORIES } from "@/data/products";

const norm = (s) => s.toLowerCase().replace(/₂/g, "2").replace(/[^a-z0-9.\s]/g, " ");
const tokens = (s) => [...new Set(norm(s).split(/[\s.]+/).filter(Boolean))];

const STOP = new Set(["for", "the", "and", "of", "a", "an", "in", "with", "to", "on", "need", "want", "buy", "price", "best", "type", "types", "fire"]);
const ALIASES = {
  cylinder: "extinguisher", fireball: "ball", c02: "co2", carbon: "co2", dcp: "powder", dry: "powder", oxygen: "breathing",
  scba: "breathing", mask: "hood", signage: "sign", board: "sign", lamp: "light", bulb: "light", lighting: "light",
  sensor: "detector", siren: "hooter", jacket: "suit", wheelchair: "chair", li: "lithium", ion: "lithium",
  cupboard: "cabinet", almirah: "cabinet", speaker: "voice", pa: "voice", announcement: "voice", shoes: "boots",
  vehicle: "ev", car: "ev", casualty: "stretcher", injured: "stretcher", ambulance: "stretcher", glow: "photoluminescent",
  radium: "photoluminescent", cooking: "kitchen", ups: "battery", set: "apparatus", kit: "apparatus", baby: "infant", babies: "infant", kid: "child", kids: "child",
};

const lev = (a, b, max) => {
  if (Math.abs(a.length - b.length) > max) return max + 1;
  let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    const cur = [i];
    for (let j = 1; j <= b.length; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    prev = cur;
  }
  return prev[b.length];
};

const quality = (alts, toks) => {
  let best = 0;
  for (const a of alts) {
    const k = a.length >= 8 ? 2 : a.length >= 4 ? 1 : 0;
    for (const t of toks) {
      if (t === a || (a.length > 2 && t.startsWith(a))) return 1;
      if (a.length >= 4 && t.includes(a)) best = Math.max(best, 0.8);
      else if (k && (lev(a, t, k) <= k || (a.length >= 5 && lev(a, t.slice(0, a.length), k) <= k))) best = Math.max(best, 0.7);
    }
  }
  return best;
};

const INDEX = CATEGORIES.flatMap((c) =>
  c.products.map((p) => ({
    p,
    c,
    fields: [
      [tokens(p.name), 3],
      [tokens(c.name), 1.5],
      [tokens([p.tagline, ...c.standards, ...p.uses, ...c.industries, ...p.specs.flat(), c.short, ...(p.models || []).flatMap((m) => [m.code, m.code.replace(/-/g, ""), m.name])].join(" ")), 1],
    ],
  }))
);

export const SEARCH_SUGGESTIONS = ["Extinguisher", "Stretcher", "Exit light", "Fire ball", "Smoke detector", "EV blanket", "Breathing set", "Kitchen"];

export function searchProducts(query, limit = 24) {
  const words = tokens(query).filter((w) => !STOP.has(w));
  if (!words.length) return { results: [], closest: false };
  const alts = words.map((w) => {
    const stem = w.length > 3 && w.endsWith("s") && !w.endsWith("ss") ? w.slice(0, -1) : w;
    return [...new Set([w, stem, ALIASES[w], ALIASES[stem]].filter(Boolean))];
  });
  const scored = INDEX.map((e) => {
    const per = alts.map((a) => e.fields.reduce((s, [toks, wt]) => s + quality(a, toks) * wt, 0));
    return { ...e, matched: per.filter((s) => s > 0).length, score: per.reduce((s, x) => s + x, 0) };
  }).filter((e) => e.matched > 0);
  const full = scored.filter((e) => e.matched === words.length);
  const list = full.length ? full : scored;
  list.sort((a, b) => b.matched - a.matched || b.score - a.score);
  const top = list[0]?.score || 0;
  return { results: list.filter((e) => e.matched === list[0].matched && e.score >= top * 0.4).slice(0, limit), closest: !full.length && list.length > 0 };
}
